import type { AxiosInstance } from "axios";
import { GeneratedClient } from "./Client.generated";
import { getApiBaseUrlFromHostname } from "../helpers/api";

export class Client extends GeneratedClient {
    constructor(baseUrl?: string, instance?: AxiosInstance) {
        const configuredBaseUrl =
            ((window as any)?.API_BASE_URL as string) ||
            (process.env.REACT_APP_ALD_SERVER as string) ||
            "";
        const resolvedBaseUrl = getApiBaseUrlFromHostname(
            window.location.hostname,
            configuredBaseUrl
        );
        super(baseUrl ?? resolvedBaseUrl, instance);
    }
}

export * from "./Client.generated";
export { GeneratedClient };
